// extracted by mini-css-extract-plugin
module.exports = {"payment-list":"PaymentList_payment-list__3aDbK"};